// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__2OZWD","modal":"Modal_modal__3F44x","header":"Modal_header__1JoMJ","closeBtn":"Modal_closeBtn__-FZBu"};